import React, { useState } from 'react';
import './AdminForms.css';

export default function AddEpisode() {
  const [formData, setFormData] = useState({
    newTitle: '', newDescription: '', speaker: '', videoURL: '',
    flyer: '', slides: '', date: '', type: 'episode',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);
    try {
      const res = await fetch('/api/newEpisode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (data.success) {
        setSuccess('Episode added successfully!');
        setFormData({ newTitle: '', newDescription: '', speaker: '', videoURL: '', flyer: '', slides: '', date: '', type: 'episode' });
      } else {
        setError(data.message || 'Failed to add episode');
      }
    } catch (err) {
      setError('An error occurred');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-form-view">
      <h1>Podcast — Add Episode</h1>
      {error && <div className="admin-form-error">{error}</div>}
      {success && <div className="admin-form-success">{success}</div>}

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="admin-form-field">
          <label>Title</label>
          <input name="newTitle" value={formData.newTitle} onChange={handleChange} required />
        </div>

        <div className="admin-form-field">
          <label>Description</label>
          <textarea name="newDescription" rows={3} value={formData.newDescription} onChange={handleChange} required />
        </div>

        <div className="admin-form-field">
          <label>Guest speaker</label>
          <input name="speaker" value={formData.speaker} onChange={handleChange} />
        </div>

        <div className="admin-form-field">
          <label>Video URL</label>
          <input name="videoURL" value={formData.videoURL} onChange={handleChange} required />
        </div>

        <div className="admin-form-row">
          <div className="admin-form-field">
            <label>Link to flyer</label>
            <input name="flyer" value={formData.flyer} onChange={handleChange} />
          </div>
          <div className="admin-form-field">
            <label>Link to slides</label>
            <input name="slides" value={formData.slides} onChange={handleChange} />
          </div>
        </div>

        <div className="admin-form-field">
          <label>Date</label>
          <input name="date" type="date" value={formData.date} onChange={handleChange} required />
        </div>

        <button type="submit" className="mihu-btn-primary-lg admin-form-submit" disabled={loading}>
          {loading ? 'Submitting…' : 'Submit'}
        </button>
      </form>
    </div>
  );
}
